import React from 'react';
import GelEnvelopeDashboardPage from '../GelEnvelopeDashboardPageV2';

/* G133 — wire scoped Audit to v2 GEL envelope dashboard.
 * In v1, "Native Audit" = "GEL Envelope Dashboard scoped to native" — same
 * data, just filtered. */
export default function NativeAuditPage() {
  return <GelEnvelopeDashboardPage agentScope="native" />;
}
